import Vue from "vue";
import Router from "vue-router";
import { app } from "@/firebase";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      name: "unauthorized",
      path: "/unauthorized",
      component: () => import("@/views/Unauthorized"),
    },
    {
      name: "hotels",
      path: "/hotels",
      component: () => import("@/views/Hotels.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      name: "login",
      path: "/login",
      component: () => import("@/views/LoginView"),
    },
    {
      path: "/",
      redirect: "/login",
      component: () => import("@/views/Layout"),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          name: "settings",
          path: "/:hotel/settings",
          redirect: "/:hotel/settings/customization",
          component: () => import("@/views/SettingsView"),
          children: [
            {
              name: "settings-customization",
              path: "/:hotel/settings/customization",
              component: () =>
                import("@/components/SettingsPage/CustomizationTab"),
            },
            {
              name: "settings-help",
              path: "/:hotel/settings/help",
              component: () => import("@/components/SettingsPage/HelpTab"),
            },
          ],
        },
        {
          name: "rooms",
          path: "/:hotel/rooms",
          redirect: "/:hotel/rooms/list",
          component: () => import("@/views/RoomView"),
          children: [
            {
              name: "room-list",
              path: "/:hotel/rooms/list",
              component: () => import("@/components/RoomsPage/RoomsList"),
            },
            {
              name: "room-messages",
              path: "/:hotel/rooms/messages",
              component: () =>
                import("@/components/MessagesPage/MessageScheduler"),
            },
          ],
        },
        {
          name: "edit",
          path: "/:hotel/edit",
          component: () =>
            import("@/components/EditGuestbookPage/GuestbookPage"),
        },
        {
          name: "statistics",
          path: "/:hotel/statistics",
          component: () => import("@/views/StatisticsView"),
          redirect: "/:hotel/statistics/platform",
          children: [
            {
              name: "platform-statistics",
              path: "/:hotel/statistics/platform",
              component: () =>
                import(
                  "@/components/StatisticsPage/StatisticsGuests/StatisticsGuests"
                ),
            },
            {
              name: "voucher-statistics",
              path: "/:hotel/statistics/voucher",
              component: () =>
                import(
                  "@/components/StatisticsPage/StatisticsVouchers/StatisticsVouchers"
                ),
            },
            {
              name: "products-statistics",
              path: "/:hotel/statistics/products",
              component: () =>
                import(
                  "@/components/StatisticsPage/StatisticsProducts/StatisticsProducts"
                ),
            },
          ],
        },
        {
          name: "media",
          path: "/:hotel/media",
          component: () => import("@/views/MediaView"),
          redirect: "/:hotel/media/images",
          children: [
            {
              name: "media-images",
              path: "/:hotel/media/images",
              component: () => import("../components/MediaPage/MediaImages"),
            },
            {
              name: "media-pdf",
              path: "/:hotel/media/pdf",
              component: () => import("../components/MediaPage/MediaPdfs"),
            },
          ],
        },
        {
          name: "pages",
          path: "/:hotel/pages",
          component: () => import("@/views/PagesView"),
          redirect: "/:hotel/pages/list",
          children: [
            {
              name: "list-pages",
              path: "/:hotel/pages/list",
              component: () => import("@/components/PagesPage/PagesOverview"),
            },
            {
              name: "new-page",
              path: "/:hotel/new-page",
              component: () => import("@/components/PagesPage/PagesCreateNew"),
            },
          ],
        },
        {
          name: "qr-code",
          path: "/:hotel/qr-code",
          component: () => import("@/views/QRView"),
        },
        {
          name: 'event-list',
          path: '/:hotel/event-list',
          component: () => import('@/views/EventsView')
        }
      ],
    },
  ],
});

// todo: could be useful for tailwind refactor.
if (process.env.NODE_ENV !== "production") {
  router.addRoutes([
    {
      path: "/global-css-test",
      name: "Global CSS Test",
      component: () => import("@/views/GlobalStylingTestView"),
    },
  ]);
}

router.addRoutes([
  {
    name: "not-found",
    path: "*",
    component: () => import("@/views/NotFound"),
  },
]);

router.beforeEach((to, from, next) => {
  let currentUser = app.auth().currentUser;
  let requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next("login");
  else next();
});

export default router;
